import { ContractType, UnitDecimals } from '~/constants';

// Offtake bids are priced either per kWh (PPA) or as a flat per-year amount
// (lease / energy service agreement). Per-year amounts are whole dollars, so
// they should render with no decimal places; per-kWh rates keep their cents.
export const isPerYearOfftake = (contractType?: string | null) =>
  contractType !== ContractType.PPA;

// Number of decimal places to show for an offtake bid amount. Routed through
// UnitDecimals so the per-year/per-kWh precision stays the single source of truth.
export const offtakeBidDecimals = (contractType?: string | null) =>
  isPerYearOfftake(contractType) ? UnitDecimals.YEAR : UnitDecimals.KWH;

// Bare unit for an offtake rate, e.g. 'year' or 'kWh'. Callers compose the
// surrounding punctuation ('$/year', '/kWh', ...) so it reads naturally in context.
export const offtakeRateUnit = (contractType?: string | null) =>
  isPerYearOfftake(contractType) ? 'year' : 'kWh';
